import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import StepItem from 'components/StepItem/StepItem';
import { BUTTON_VARIANT } from 'constants/interfaces';

import Panel from '../../../../../components/Panel/Panel';
import PrioritiseTopics from './components/PrioritiseTopics';

import type { ISurveyAnswerPrioritiseProps } from './interfaces/ISurveyAnswerPrioritiseProps';

import styles from './scss/SurveyAnswerPrioritise.module.scss';

function SurveyAnswerPrioritiseView({
  control, onCancel, onNextStep, onReview, standardTopicsData, currentStep,
}: ISurveyAnswerPrioritiseProps) {
  const { t } = useTranslation();

  return (
    <Panel className={styles.panel}>
      <p className={styles.title}>{t('materialityAssessment.specifyYourPriorities')}</p>
      <div className={styles.steps}>
        <StepItem
          title={t('materialityAssessment.selectTopics')}
          step={1}
          disabled={currentStep < 1}
        />
        <ArrowRightIcon />
        <StepItem
          title={t('materialityAssessment.selectSubTopics')}
          step={2}
          disabled={currentStep < 2}
        />
        <ArrowRightIcon />
        <StepItem
          title={t('materialityAssessment.prioritise')}
          step={3}
          disabled={currentStep < 3}
        />
      </div>
      <PrioritiseTopics
        control={control}
        standardTopicsData={standardTopicsData}
        currentStep={currentStep}
      />
      <div className={styles.footer}>
        <Button
          title={t('common.cancel')}
          className={styles.nextStep}
          variant={BUTTON_VARIANT.secondary}
          onClick={onCancel}
        />
        <Button
          title={currentStep === 3 ? t('common.review') : t('materialityAssessment.continue')}
          className={styles.nextStep}
          variant={BUTTON_VARIANT.primary}
          onClick={currentStep === 3 ? () => onReview() : onNextStep}
        />
      </div>
    </Panel>
  );
}

export default SurveyAnswerPrioritiseView;
